/**
 * React Query cache key factories for the MCP Reminder API.
 */

/** Cache keys for reminder queries and mutations. */
export const reminderKeys = {
  all: ['reminders'] as const,
  /** List key: `['reminders', role, selectedClientId, selectedCompanyId, params]` */
  list: (
    role: string | undefined,
    selectedClientId: string | null | undefined,
    selectedCompanyId: string | null | undefined,
    params?: unknown
  ) => [...reminderKeys.all, role, selectedClientId, selectedCompanyId, params] as const,
  /** Preferences key: `['reminders', 'preferences', role, selectedClientId, selectedCompanyId]` */
  preferences: (
    role: string | undefined,
    selectedClientId: string | null | undefined,
    selectedCompanyId: string | null | undefined
  ) => [...reminderKeys.all, 'preferences', role, selectedClientId, selectedCompanyId] as const,
};
